import React, { useState, useEffect, useContext } from 'react'
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner'
import './Players.css'

const AddPhotoOrVideosNote = () => {
	return (
		<React.Fragment>
			<container className='addPhotoOrVideoNote'>
				<p className='noteFont'>You could add your player photo here!</p>
				<p className='noteFont'>
					Have a video of a sweet goal or killer save? Get it added to their
					page!
				</p>
				<p className='noteFont clickToFindOutHow'>Click to find out how!</p>
			</container>
		</React.Fragment>
	)
}

export default AddPhotoOrVideosNote
